import { Modal, Table } from "../../../../components";
import { useAdminStore } from "../../../../store/adminStore";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { motion } from "framer-motion";
import ViewMap from "../../../../components/ViewMap";
import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { handlerCambiarEstado, handlerCancelar } from "../../../../handlers/actas.handler";
import { usePodadoresStore } from "../../../../store/podadoresStore";
import { tableDataPodadores } from "../tableDataPodadores";
import useWindowSize from "../../../../hooks/useWindowSize";
import ModalAsignarPodadores from "./ModalAsignarPodadores";
import { useFormActaStore } from "../../../../store/formActaStore";

const ModalPodadores = () => {
  const { modals, handlerModal } = useGeneralAppStore();
  const { podadores, podadoresSelect, setPodadoresSelect } = usePodadoresStore();
  const size = useWindowSize();
  const { width } = size;
  const { defaultValues } = useFormActaStore();
  /* const [podadoresSelect, setPodadoresSelect] = useState([]) */

  useEffect(() => {
    if (defaultValues.podadores.length > 0) {
      setPodadoresSelect(defaultValues.podadores);
    }

    return () => {
      setPodadoresSelect([]);
      handlerModal({ modal: false, modalName: "podadores" });
    };
  }, []);

  return (
    <>
      <Modal
        // fullscreen={true}
        size="xl"
        show={modals.includes("podadores")}
        onHide={() => handlerModal({ modal: false, modalName: "podadores" })}
        title={() => "Podadores"}
      >
        <motion.div
          key="form"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="w-100"
        >
          <Alert>
            Comuniquese con el podador antes de seleccionar a dicho <b>trámite</b>, para coordinar
            asistencia , día y hora{" "}
          </Alert>

          <div className=" my-3">
            <button
              disabled={podadoresSelect.length == 0}
              onClick={() => {
                handlerModal({ modal: true, modalName: "asignar_podadores" });
              }}
              className=" btn btn-primary btn-sm fw-bold text-white"
            >
              Asignar {podadoresSelect?.length} podador/es
            </button>
          </div>

          <Table
            search={true}
            height={"60vh"}
            data={tableDataPodadores(
              podadores,
              width,
              podadoresSelect /* setPodadoresSelect, */ /* podadoresSelect */
            )}
            renderButtonFooter={() => {
              return (
                <>
                  {width >= 360 && (
                    <div className="">
                      <button
                        disabled={podadoresSelect.length == 0}
                        onClick={() => {
                          handlerModal({ modal: true, modalName: "asignar_podadores" });
                        }}
                        className=" btn btn-primary btn-sm fw-bold text-white"
                      >
                        Asignar {podadoresSelect.length} podador/es
                      </button>
                    </div>
                  )}
                </>
              );
            }}
          />
        </motion.div>
        {modals.includes("asignar_podadores") && <ModalAsignarPodadores />}
      </Modal>
    </>
  );
};
export default ModalPodadores;
